(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kit-buy-button"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('marine-kit-buy'))customElements.define('marine-kit-buy',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  this.button=this.querySelector('[data-kit-buy]');
  this.button.addEventListener('click',()=>this.add());
 }
 async add(){
  if(this.busy||this.uncertain||this.button.disabled)return;
  const grouped=new Map();
  for(const part of this.querySelectorAll('[data-kit-part]')){
   const id=part.dataset.id,quantity=Number(part.dataset.quantity);
   if(!/^\d+$/.test(id)||!Number.isSafeInteger(quantity)||quantity<1)return;
   grouped.set(id,(grouped.get(id)||0)+quantity);
  }
  if(!grouped.size)return;
  this.busy=true;this.button.disabled=true;this.button.classList.add('loading');this.button.setAttribute('aria-busy','true');
  this.querySelector('.button-overlay-spinner').classList.remove('hidden');
  const error=this.querySelector('[data-kit-error]');error.hidden=true;
  const minicart=document.querySelector('mini-cart');let attempted=false,added=false;
  try{
   const sections=(minicart?.getSectionsToRender?.()||[]).slice(0,5);
   const group=crypto.randomUUID();
   const properties={_marine_kit:this.dataset.kitId,_marine_group:group,_marine_revision:this.dataset.kitRevision};
   const payload={items:[...grouped].map(([id,quantity])=>({id,quantity,properties}))};
   if(sections.length){payload.sections=sections.map(s=>s.section);payload.sections_url=location.pathname;}
   attempted=true;
   const response=await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
   const data=await response.json();
   if(!response.ok||data.status)throw Error('Cart update failed');
   added=true;
   if(window.themeSettings?.redirectToCart||!minicart||!sections.length||sections.some(s=>!data.sections?.[s.section])){this.uncertain=true;location.assign(this.dataset.cart);return;}
   minicart.renderContents(data);
   const drawer=this.closest('quick-view-drawer');
   if(drawer){drawer.close();document.body.classList.add('drawer-open');setTimeout(()=>minicart.open(),200);}else minicart.open(this.button);
   if(typeof publish==='function'&&typeof PUB_SUB_EVENTS!=='undefined')publish(PUB_SUB_EVENTS.cartItemAdd,{source:'MarineKit',items:data.items||[]});
  }catch(e){
   this.uncertain=attempted;
   if(added){location.assign(this.dataset.cart);return;}
   error.textContent='Unable to confirm the full kit was added. Review your cart, then reload this page before trying again. ';
   const link=document.createElement('a');link.href=this.dataset.cart;link.textContent='View cart';error.append(link);error.hidden=false;
  }finally{
   this.busy=false;this.button.disabled=Boolean(this.uncertain);this.button.classList.remove('loading');this.button.removeAttribute('aria-busy');this.querySelector('.button-overlay-spinner').classList.add('hidden');
  }
 }
});
  } catch(e) { console.error(e); }
})();

})();
